<template>
    <div>
        <div class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center profile-header" style="min-height: 200px;">
            <b-container fluid>
                <span class="mask bg-gradient-success opacity-8"></span>
            </b-container>
        </div>
        <b-container v-if="isLoading" fluid class="mt--7">
            <card><p>Loading...</p></card>
        </b-container>
        <b-container v-else fluid class="mt--7">
            <card>
                <div class="d-flex flex-row-reverse">
                    <button class="btn btn-success" @click="saveBrand()">{{brand.id!==null ? 'Save' : 'Create'}}</button>
                </div>
                <b-row>
                    <b-col>
                        <base-input label="ID" placeholder="ID" :readonly="true" v-model="brand.id" />
                        <base-input label="Phone unique">
                            <base-checkbox v-model="brand.phone_unique" />
                        </base-input>
                    </b-col>
                    <b-col>
                        <base-input label="Name" placeholder="Name" v-model="brand.name" />
                        <base-input label="Name unique">
                            <base-checkbox v-model="brand.name_unique" />
                        </base-input>
                    </b-col>
                    <b-col>
                        <base-input label="Company" placeholder="Company" v-model="brand.company" />
                        <base-input label="Address unique">
                            <base-checkbox v-model="brand.address_unique" />
                        </base-input>
                    </b-col>
                    <b-col>
                        <base-input label="Country">
                            <b-dropdown v-if="!countriesLoading" variant="outline-light" :text="countries[brand.country]">
                                <b-dropdown-item v-for="(country,index) in countries" v-bind:key="index" @click="brand.country=index">{{country}}</b-dropdown-item>
                            </b-dropdown>
                            <p v-else>Countries loading ...</p>
                        </base-input>
                        
                        <base-input label="Name - address combined unique">
                            <base-checkbox v-model="brand.name_address_unique" />
                        </base-input>
                    </b-col>
                </b-row>
            </card>
        </b-container>
    </div>
</template>

<script>
import RepositoryFactory from "@/repositories/RepositoryFactory"

const BrandRepository = RepositoryFactory.get('brand');
const CountryRepository = RepositoryFactory.get('country');

export default {
    props:{
        id:String,
    },
    data(){
        return {
            isLoading:true,
            brand:null,

            countriesLoading:true,
            countries:null
        }
    },
    created(){
        this.getCountries();

        if(this.id==='new'){
            this.brand={
                id:null,
                name:null,
                country:null,
                company:null,
                name_unique:null,
                phone_unique:null,
                address_unique:null,
                name_address_unique:null,
            }
            this.isLoading=false;
        }
        else{
            BrandRepository.get(this.id).then((response) => {
                this.brand=response.data[0];
                this.isLoading=false;
            })
        }
    },
    methods:{
        getCountries(){
            this.countriesLoading=true;
            CountryRepository.get().then((response) => {
                this.countries={null:'No country'}

                for(var i in response.data){
                    var country=response.data[i];
                    this.countries[country.id]=country.name;
                }
                this.countriesLoading=false;
            })
        },
        saveBrand(){
            var id=this.brand.id;
            var payload=this.copyObject(this.brand);
            delete payload.id;

            if(payload.country=="null"){
                payload.country=null
            }
            
            if(id!==null){ // Güncelle
                BrandRepository.put(id,payload).then((response) => {
                    this.$notify({
                        message: 'Brand saved: '+this.brand.name,
                        type: 'info',
                        size: 'lg',
                        timeout: 5000,
                        showClose: true
                    });
                })
            }
            else { // Oluştur
                BrandRepository.post(payload).then((response) => {
                    this.brand.id=response.data.id;
                    this.$router.push({name:'brand',params:{id:this.brand.id}});
                })
            }
        }
    }
}
</script>

<style>

</style>